import {
    Box, Heading, Text
} from "@chakra-ui/react";
const Contact = (props) => {
    return (
        <Box mb="100px" fontSize="14px" fontWeight="500">
            <Text>For more information, please contact:</Text>
            <Heading fontSize="26px" fontWeight="700">{props.data?.firstName} {props.data?.lastName}</Heading>
            <Text>Email: {props.data?.email}</Text>
            <Text>Phone: {props.data?.phoneNumber}</Text>
        </Box>
    );
}

export default Contact;